import { connect } from 'react-redux';

import Menu from './Menu';

function mapStateToProps() {
  // TODO: Pass appropriate props to the component to indicate the integration
  // status and loading state.
  return {};
}

export default connect(mapStateToProps)(Menu);
